import { createFileRoute } from '@tanstack/react-router'
import WaterCharts from '@/components/field/insights/WaterCharts'
import DateRangePickerWithPresets from '@/components/inputs/DateRangePickerWithPresets'
import { RangeValue, DateValue } from '@heroui/react'
import { useState } from 'react'
import dayjs from 'dayjs'
import { parseDate } from '@internationalized/date'

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/insights/hydroflow',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const [dateRange, setDateRange] = useState<RangeValue<DateValue> | null>({
    start: parseDate(dayjs().subtract(2, 'weeks').format('YYYY-MM-DD')),
    end: parseDate(dayjs().format('YYYY-MM-DD')),
  })

  return (
    <div className="flex flex-col gap-2">
      <DateRangePickerWithPresets
        value={dateRange}
        onChange={setDateRange}
        label="Date Range"
      />
      <WaterCharts dateRange={dateRange} />
    </div>
  );
}
